// extracted by mini-css-extract-plugin
export default {"container":"UserDetails_container__hGMOZ","form":"UserDetails_form__djknb"};